export {
  SButtonActions as DirectiveButtonActions,
  SWizardContent as DirectiveContent,
  SContainer as DirectiveContainer,
} from './DirectiveContent.styled'
